import { useRef, useLayoutEffect, useState } from "react";

export const useElementDimensions = () => {
    const targetRef = useRef();
    const [width, setWidth] = useState(0);


    const element_dimensions = () => {
      if (targetRef.current !== undefined) {
        setWidth(targetRef.current.offsetWidth);
      }
    };

    useLayoutEffect(() => {
      window.addEventListener("resize", element_dimensions());
      return () => window.removeEventListener("resize", element_dimensions());
    });


    return [{ width }, targetRef];

}